import { Breadcrumb, Button, Col, Row, Table } from "antd";
import Search from "antd/es/input/Search";
import { ColumnsType, TableProps } from "antd/es/table";
import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ArrowLeftOutlined, PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useGetAPIMastersGetStudentList } from "../../../Generated/orval-apis/masters/masters";
import GenerateCard from "./GenerateCard";
import { selectBatchState } from "../../../Store/Slice/batchSlice";
import { selectDepartmentState } from "../../../Store/Slice/departmentSlice";

export const pageSizeOption: number[] = [10, 15, 30, 50, 100, 200];

// interface IUserTable {
//   machineTitle: string;
//   machineNo: string;
// }

type TableRowSelection<T extends object = object> =
  TableProps<T>["rowSelection"];

export const IDCardTemplate = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const [search, setSearch] = useState<any>("");
  const navigate = useNavigate();
  // const [form] = Form.useForm();
  const [cardModalVisible, setCardModalVisible] = useState<boolean>(false);
  // const [selectedStudentId, setSelectedStudentId] = useState<string[]>([]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys?.map((id) => id?.toString()));
  };
  const handleCardDownloaded = () => {
    setSelectedRowKeys([]);
    setCardModalVisible(false);
  };

  const columns: ColumnsType<any> = [
    {
      title: "S. No",
      dataIndex: "sNo",
      width: "70px",
      render: (_, record, index) => <p>{index + 1}</p>,
    },

    {
      title: "Student ID",
      dataIndex: "studentId",
      key: "studentId",
      width: 150,
      render: (text, record) => <>{text}</>,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Department",
      dataIndex: "departmentName",
      key: "departmentName",
      width: 240,
      ellipsis: true,
    },
    {
      title: "Course",
      dataIndex: "courseName",
      key: "courseName",
      width: 240,
      ellipsis: true,
    },
    {
      title: "Batch",
      dataIndex: "batchName",
      key: "batchName",
      width: 240,
      ellipsis: true,
    },
    {
      title: "Semester",
      dataIndex: "semeseterName",
      key: "semeseterName",
      width: 200,
      ellipsis: true,
    },
    {
      title: "Section",
      dataIndex: "sectionName",
      key: "sectionName",
      width: 200,
      ellipsis: true,
    },
  ];

  const batchId = useSelector(selectBatchState);
  const depId = useSelector(selectDepartmentState);

  useEffect(() => {
    setSelectedRowKeys([]);
    setSearch("");
  }, [batchId, depId]);

  const { data: studentList, isLoading: studentLoading } =
    useGetAPIMastersGetStudentList({
      departmentId: depId,
      search: search,
      batchId: batchId,
    });

  const rowSelection: TableRowSelection<any> = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleSearch = (e: any) => {
    setSearch(e);
  };

  return (
    <>
      <Row
        justify={"space-between"}
        align="middle"
        style={{ marginBottom: "6px" }}
      >
        <ArrowLeftOutlined
          style={{ color: "#1677ff" }}
          onClick={() => {
            navigate("/settings");
          }}
        />
        <Breadcrumb
          style={{ color: "#172B4D" }}
          items={[
            {
              title: "Identity Cards Template",
            },
          ]}
        ></Breadcrumb>
      </Row>
      <Row className="roundedCornerSmall bg-white" style={{ padding: "16px" }}>
        <Col span={24}>
          <Row justify={"end"}>
            <Col lg={3}>
              <Search
                onSearch={(e: any) => handleSearch(e)}
                // onPressEnter={(e:any)=>handleSearch(e)}
                placeholder="Search Name..."
                allowClear
                className="att-search-input mb-1"
                // onSearch={(val: string) => changeListParams("nameSearch", val)}
                // onChange={(e: any) =>
                //   e.target.value === "" ? setListParamsAndRefresh("") : null
                // }
                style={{ width: "100%" }}
              />
            </Col>
            <Col>
              <Button
                type="primary"
                className="cit-add-btn mb-1 ms-2"
                disabled={selectedRowKeys.length === 0}
                onClick={() => {
                  setCardModalVisible(true);
                }}
              >
                <PlusOutlined />
                Generate Card
              </Button>
            </Col>
          </Row>
          <Col span={24} style={{ paddingTop: "12px" }}>
            <Table
              rowKey={(record) => record?.id}
              rowSelection={rowSelection}
              size="small"
              dataSource={studentList?.result || []}
              loading={studentLoading}
              columns={columns}
              scroll={{ x: 1100, y: "75vh" }}
              pagination={false}
            />
          </Col>
        </Col>
      </Row>

      {selectedRowKeys.length > 0 && (
        <GenerateCard
          visible={cardModalVisible}
          onCancel={() => setCardModalVisible(false)}
          studentIds={selectedRowKeys || []}
          onDownloaded={handleCardDownloaded}
        />
      )}
    </>
  );
};

export default IDCardTemplate;
